/**
 * React 18 does not recognise the camelCase `fetchPriority` prop and logs a
 * warning while dropping it. Spreading the lowercase HTML attribute passes it
 * straight through. Remove this once the app is on React 19.
 *
 * Usage: <img {...HIGH_FETCH_PRIORITY} loading="eager" ... />
 */
export const HIGH_FETCH_PRIORITY = { fetchpriority: "high" } as Record<
  string,
  string
>;
